import { FileSpreadsheet, Settings, Upload } from 'lucide-react'
import { Button } from '~/components/ui/button'

interface ReapproCategoriesToolbarProps {
  isUserAdmin: boolean
  onConfigure: () => void
  onStocksMin: () => void
  onImport: () => void
  onSimulation: () => void
}

export const ReapproCategoriesToolbar = ({
  isUserAdmin,
  onConfigure,
  onStocksMin,
  onImport,
  onSimulation,
}: ReapproCategoriesToolbarProps) => (
  <div className="flex flex-wrap items-center justify-start gap-2 p-2">
    <Button variant="outline" disabled={!isUserAdmin} onClick={onConfigure}>
      <Settings />
      Configurer
    </Button>
    <Button variant="outline" disabled={!isUserAdmin} onClick={onStocksMin}>
      <FileSpreadsheet />
      Stocks min
    </Button>
    <Button variant="outline" disabled={!isUserAdmin} onClick={onImport}>
      <Upload />
      Import modifications
    </Button>
    <Button
      disabled={!isUserAdmin}
      className="bg-[#FF9F00] hover:bg-[#e68f00] text-white"
      onClick={onSimulation}
    >
      <FileSpreadsheet />
      Simulation générale
    </Button>
  </div>
)
